import React, {useEffect,useState} from 'react'
import {fetchAllBlog, blogSelector} from '../../api/blog'
import {loginSelector} from '../../api/authSlice'
import {useDispatch, useSelector} from 'react-redux'
import Loader from '../../shared/loader'
import DataTable from './datatable'
import { Button } from 'antd'
import { Link } from 'react-router-dom'
import { Input  } from 'antd';
import { useDebounce } from "use-debounce";


// const {FormItem} = Form
export default function Blog() {

  const dispatch = useDispatch()
  const {blog } = useSelector(blogSelector)
  const {filter} = useSelector(loginSelector)
  console.log(filter);
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(false)
  const [debouncedText] = useDebounce(search, 1000)

  console.log({blog})

useEffect(()=>{
dispatch(fetchAllBlog())
}, [dispatch])

const { Search } = Input;




    return (<>
<div className="mb-4 float-right ">
    <div className="mx-3">

{/* <Search placeholder="Search Blog" className="mx-3" style={{ width: 230 }} enterButton /> */}
    <Button type="primary">
        <Link className=' text-white' to="/admin/create-blog">Add Blog</Link>
    </Button> 
</div>
</div>
{

 <DataTable loading={loading}
 data ={(filter.length> 0) ? filter : blog}/>

}
    </>
       )
}  







